import state from '../store/state.js';
// 开发环境不使用懒加载, 因为懒加载页面太多的话会造成webpack热更新太慢
const _import = require('./import-' + process.env.NODE_ENV)

function getProps (route) {
  return route.query;
}

// 系统生成路由
const routers = [
  { path: '/login', component: _import('login/index'), name: 'login', props: getProps, desc: '登录' },
  { path: '/register', component: _import('register/index'), name: 'register', props: getProps, desc: '注册' },
  { path: '/findPassword', component: _import('findPassword/index'), name: 'findPassword', props: getProps, desc: '忘记密码' },
  {
    path: '/',
    component: _import('login/index'),
    name: 'root'
  },
  {
    path: '/main',
    component: _import('layout/index'),
    name: 'main',
    props: getProps,
    redirect: {
      name: 'welcome'
    },
    meta: {
      title: '主页',
      showOnly: true
    },
    children: [
      {path: 'formSysUser', component: _import('upms/formSysUser/index'), name: 'formSysUser', meta: {title: '用户管理'}},
      {path: 'formSysDept', component: _import('upms/formSysDept/index'), name: 'formSysDept', meta: {title: '部门管理'}},
      {path: 'formSysRole', component: _import('upms/formSysRole/index'), name: 'formSysRole', meta: {title: '角色管理'}},
      {path: 'formSysDataPerm', component: _import('upms/formSysDataPerm/index'), name: 'formSysDataPerm', meta: {title: '数据权限管理'}},
      {path: 'formSysMenu', component: _import(state.supportColumn ? 'upms/formSysMenu/formSysColumnMenu' : 'upms/formSysMenu/index'), name: 'formSysMenu', meta: {title: '菜单列表'}},
      {path: 'formSysDict', component: _import('upms/formDictManagement/index'), name: 'formSysDict', meta: {title: '字典管理'}},
      {path: 'formSysPermCode', component: _import('upms/formSysPermCode/index'), name: 'formSysPermCode', meta: {title: '权限字管理'}},
      {path: 'formSysPerm', component: _import('upms/formSysPerm/index'), name: 'formSysPerm', meta: {title: '权限资源管理'}},
      {path: 'formSysOperationLog', component: _import('upms/formSysOperationLog/index'), name: 'formSysOperationLog', meta: {title: '操作日志'}},
      {path: 'formSysLoginUser', component: _import('upms/formSysLoginUser/index'), name: 'formSysLoginUser', meta: {title: '在线用户'}},
      // 岗位模块路由配置
      {path: 'formSysPost', component: _import('upms/formSysPost/index'), name: 'formSysPost', meta: {title: '岗位管理'}},
      {path: 'formSysDeptPost', component: _import('upms/formSysDeptPost/index'), name: 'formSysDeptPost', props: getProps, meta: {title: '设置部门岗位'}},
      // 在线表单模块路由配置
      {path: 'formOnlineDict', component: _import('onlineForm/formOnlineDict/index'), name: 'formOnlineDict', props: getProps, meta: {title: '在线表单字典管理'}},
      {path: 'formOnlinePage', component: _import('onlineForm/formOnlinePage/index'), name: 'formOnlinePage', props: getProps, meta: {title: '在线表单管理'}},
      {path: 'onlineForm', component: _import('onlineForm/index'), name: 'onlineForm', props: getProps, meta: {title: '在线表单'}},
      // 工作流模块路由配置
      {path: 'formMessage', component: _import('workflow/formMessage/index'), name: 'formMessage', props: getProps, meta: {title: '催办消息'}},
      {path: 'formFlowCategory', component: _import('workflow/flowCategory/formFlowCategory'), name: 'formFlowCategory', props: getProps, meta: {title: '流程分类管理'}},
      {path: 'formFlowEntry', component: _import('workflow/flowEntry/formFlowEntry'), name: 'formFlowEntry', props: getProps, meta: {title: '流程设计'}},
      {path: 'formAllInstance', component: _import('workflow/taskManager/formAllInstance'), name: 'formAllInstance', props: getProps, meta: {title: '流程实例'}},
      {path: 'formMyTask', component: _import('workflow/taskManager/formMyTask'), name: 'formMyTask', props: getProps, meta: {title: '我的待办'}},
      {path: 'formMyApprovedTask', component: _import('workflow/taskManager/formMyApprovedTask'), name: 'formMyApprovedTask', props: getProps, meta: {title: '已办任务'}},
      {path: 'formMyHistoryTask', component: _import('workflow/taskManager/formMyHistoryTask'), name: 'formMyHistoryTask', props: getProps, meta: {title: '历史流程'}},
      {
        path: 'handlerFlowTask',
        component: _import('workflow/handlerFlowTask/index'),
        name: 'handlerFlowTask',
        props: getProps,
        meta: {title: '流程处理'},
        children: [
          // 静态表单路由设置
          {
            path: 'flowSpecialistAuditForm',
            component: _import('workflow/pages/flowSpecialistAudit/flowSpecialistAuditForm'),
            name: 'flowSpecialistAuditForm',
            props: getProps,
            meta: {title: '专家认证审核表单'}
          },
          {
            path: 'flowNewsAuditForm',
            component: _import('workflow/pages/flowNewsAudit/flowNewsAuditForm'),
            name: 'flowNewsAuditForm',
            props: getProps,
            meta: {title: '内容审核表单'}
          },
          {
            path: 'flowRequirementForm',
            component: _import('workflow/pages/flowRequirementAudit/flowRequirementForm'),
            name: 'flowRequirementForm',
            props: getProps,
            meta: {title: '需求表单'}
          },
          {
            path: 'flowRequirementRelateAuditForm',
            component: _import('workflow/pages/flowRequirementRelateAudit/flowRequirementRelateAuditForm'),
            name: 'flowRequirementRelateAuditForm',
            props: getProps,
            meta: {title: '需求对接审核表单'}
          },
          {
            path: 'flowSpecialistInfoForm',
            component: _import('workflow/pages/flowSpecialistInfo/flowSpecialistInfoForm'),
            name: 'flowSpecialistInfoForm',
            props: getProps,
            meta: {title: '特派员认证表单'}
          },
          {
            path: 'flowSpecialistEveryoneAuditForm',
            component: _import('workflow/pages/flowSpecialistEveryAudit/flowSpecialistEveryoneAuditForm'),
            name: 'flowSpecialistEveryoneAuditForm',
            props: getProps,
            meta: {title: '人人都是科特派申请'}
          },
          {
            path: 'technologyTrainFlowForm',
            component: _import('workflow/pages/technologyTrainFlow/technologyTrainFlowForm'),
            name: 'technologyTrainFlowForm',
            props: getProps,
            meta: {title: '科技培训表单'}
          },
          {
            path: 'flowWorkInformationForm',
            component: _import('workflow/pages/flowWorkInformation/flowWorkInformationForm'),
            name: 'flowWorkInformationForm',
            props: getProps,
            meta: {title: '工作日志表单'}
          },
          {
            path: 'flowServiceForm',
            component: _import('workflow/pages/flowService/flowServiceForm'),
            name: 'flowServiceForm',
            props: getProps,
            meta: {title: '专家服务表单'}
          },
          {
            path: 'flowAreaWorkForm',
            component: _import('workflow/pages/flowAreaWork/flowAreaWorkForm'),
            name: 'flowAreaWorkForm',
            props: getProps,
            meta: {title: '辖区工作表单'}
          },
          {
            path: 'flowActivityForm',
            component: _import('workflow/pages/flowActivity/flowActivityForm'),
            name: 'flowActivityForm',
            props: getProps,
            meta: {title: '辖区活动表单'}
          },
          {
            path: 'flowConsultForm',
            component: _import('workflow/pages/flowConsult/flowConsultForm'),
            name: 'flowConsultForm',
            props: getProps,
            meta: {title: '问答表单'}
          }
        ]
      },
      {path: 'welcome', component: _import('welcome/index'), name: 'welcome', meta: {title: '欢迎'}},
      {
        path: 'flowSpecialistAuditList',
        component: _import('workflow/pages/flowSpecialistAudit/flowSpecialistAuditList'),
        name: 'flowSpecialistAuditList',
        props: getProps,
        meta: {title: '专家认证审核列表'}
      },
      {
        path: 'courseList',
        component: _import('course/courseList'),
        name: 'courseList',
        props: getProps,
        meta: {title: '课程管理'}
      },
      {
        path: 'coursePageEdit',
        component: _import('course/coursePageEdit'),
        name: 'coursePageEdit',
        props: getProps,
        meta: {title: '课程信息编辑'}
      },
      {
        path: 'specialist',
        component: _import('specialist/specialist'),
        name: 'specialist',
        props: getProps,
        meta: {title: '专家管理'}
      },
      {
        path: 'specialistPage',
        component: _import('specialist/specialistPage'),
        name: 'specialistPage',
        props: getProps,
        meta: {title: '专家详情页'}
      },
      {
        path: 'specialistInfoView',
        component: _import('specialist/specialistInfoView'),
        name: 'specialistInfoView',
        props: getProps,
        meta: {title: '详情'}
      },
      {
        path: 'requirementList',
        component: _import('requirement/requirementList'),
        name: 'requirementList',
        props: getProps,
        meta: {title: '需求管理列表'}
      },
      {
        path: 'requirementForm',
        component: _import('requirement/requirementForm'),
        name: 'requirementForm',
        props: getProps,
        meta: {title: '需求信息编辑页面'}
      },
      {
        path: 'serviceList',
        component: _import('service/serviceList'),
        name: 'serviceList',
        props: getProps,
        meta: {title: '专家服务管理列表'}
      },
      {
        path: 'servicForm',
        component: _import('service/servicForm'),
        name: 'servicForm',
        props: getProps,
        meta: {title: '服务信息编辑'}
      },
      {
        path: 'industryPage',
        component: _import('baseInfo/industryPage'),
        name: 'industryPage',
        props: getProps,
        meta: {title: '产业管理'}
      },
      {
        path: 'titlesPage',
        component: _import('baseInfo/titlesPage'),
        name: 'titlesPage',
        props: getProps,
        meta: {title: '职称管理'}
      },
      {
        path: 'newsPageAchieve',
        component: _import('information/newsPageAchieve'),
        name: 'newsPageAchieve',
        props: getProps,
        meta: {title: '成果体现管理'}
      },
      {
        path: 'newsPageInnovate',
        component: _import('information/newsPageInnovate'),
        name: 'newsPageInnovate',
        props: getProps,
        meta: {title: '创新改革管理'}
      },
      {
        path: 'newsPage',
        component: _import('information/newsPage'),
        name: 'newsPage',
        props: getProps,
        meta: {title: '新闻资讯管理'}
      },
      {
        path: 'newsPageEvents',
        component: _import('information/newsPageEvents'),
        name: 'newsPageEvents',
        props: getProps,
        meta: {title: '大事纪管理'}
      },
      {
        path: 'flowNewsAuditList',
        component: _import('workflow/pages/flowNewsAudit/flowNewsAuditList'),
        name: 'flowNewsAuditList',
        props: getProps,
        meta: {title: '内容审核管理列表'}
      },
      {
        path: 'newsPageView',
        component: _import('information/newsPageView'),
        name: 'newsPageView',
        props: getProps,
        meta: {title: '查看信息详情'}
      },
      {
        path: 'personInfo',
        component: _import('information/personInfo'),
        name: 'personInfo',
        props: getProps,
        meta: {title: '个人信息'}
      },
      {
        path: 'featurePage',
        component: _import('baseInfo/featurePage'),
        name: 'featurePage',
        props: getProps,
        meta: {title: '标签管理'}
      },
      {
        path: 'consultAuditPage',
        component: _import('information/consultAuditPage'),
        name: 'consultAuditPage',
        props: getProps,
        meta: {title: '专家咨询审核'}
      },
      {
        path: 'commentAudit',
        component: _import('information/commentAudit'),
        name: 'commentAudit',
        props: getProps,
        meta: {title: '评论审核'}
      },
      {
        path: 'newsPageStandard',
        component: _import('information/newsPageStandard'),
        name: 'newsPageStandard',
        props: getProps,
        meta: {title: '特派员规范'}
      },
      // 示范基地管理
      {
        path: 'demonstrationBaseList',
        component: _import('demonstrationBase/demonstrationBaseList'),
        name: 'demonstrationBaseList',
        props: getProps,
        meta: {title: '示范基地管理'}
      },
      {
        path: 'demonstrationBaseForm',
        component: _import('demonstrationBase/demonstrationBaseForm'),
        name: 'demonstrationBaseForm',
        props: getProps,
        meta: {title: '示范基地表单'}
      },
      // 服务成果管理
      {
        path: 'serviceAchievementList',
        component: _import('serviceAchievement/serviceAchievementList'),
        name: 'serviceAchievementList',
        props: getProps,
        meta: {title: '服务成果管理'}
      },
      {
        path: 'serviceAchievementForm',
        component: _import('serviceAchievement/serviceAchievementForm'),
        name: 'serviceAchievementForm',
        props: getProps,
        meta: {title: '服务成果表单'}
      },
      // 教学点管理
      {
        path: 'teachingPointList',
        component: _import('teaching/teachingPointList'),
        name: 'teachingPointList',
        props: getProps,
        meta: {title: '教学点管理'}
      },
      {
        path: 'teachingPointForm',
        component: _import('teaching/teachingPointForm'),
        name: 'teachingPointForm',
        props: getProps,
        meta: {title: '教学点表单'}
      },
      // 科技成果管理
      {
        path: 'techAchievementList',
        component: _import('tech/techAchievementList'),
        name: 'techAchievementList',
        props: getProps,
        meta: {title: '科技成果管理'}
      },
      {
        path: 'techAchievementForm',
        component: _import('tech/techAchievementForm'),
        name: 'techAchievementForm',
        props: getProps,
        meta: {title: '科技成果表单'}
      },
      // 特派员管理
      {
        path: 'techPersonnelList',
        component: _import('techPersonnel/techPersonnelList'),
        name: 'techPersonnelList',
        props: getProps,
        meta: {title: '特派员管理'}
      },
      {
        path: 'techPersonnelForm',
        component: _import('techPersonnel/techPersonnelForm'),
        name: 'techPersonnelForm',
        props: getProps,
        meta: {title: '特派员表单'}
      },
      // 工作站管理
      {
        path: 'workstationList',
        component: _import('workstation/workstationList'),
        name: 'workstationList',
        props: getProps,
        meta: {title: '工作站管理'}
      },
      {
        path: 'workstationForm',
        component: _import('workstation/workstationForm'),
        name: 'workstationForm',
        props: getProps,
        meta: {title: '工作站表单'}
      },
      {
        path: 'specialistMemberList',
        component: _import('specialist/specialistMemberList'),
        name: 'specialistMemberList',
        props: getProps,
        meta: {title: '团队成员列表'}
      },
      {
        path: 'serviceAdd',
        component: _import('service/serviceAdd'),
        name: 'serviceAdd',
        props: getProps,
        meta: {title: '服务信息新增'}
      },
      {
        path: 'flowRequirementList',
        component: _import('workflow/pages/flowRequirementAudit/flowRequirementList'),
        name: 'flowRequirementList',
        props: getProps,
        meta: {title: '需求列表'}
      },
      {
        path: 'flowRequirementRelateAuditList',
        component: _import('workflow/pages/flowRequirementRelateAudit/flowRequirementRelateAuditList'),
        name: 'flowRequirementRelateAuditList',
        props: getProps,
        meta: {title: '需求对接审核列表'}
      },
      {
        path: 'flowSpecialListInfo',
        component: _import('workflow/pages/flowSpecialistInfo/flowSpecialListInfo'),
        name: 'flowSpecialListInfo',
        props: getProps,
        meta: {title: '特派员认证管理'}
      },
      {
        path: 'flowSpecialListInfoThirteen',
        component: _import('workflow/pages/flowSpecialistInfo/flowSpecialListInfoThirteen'),
        name: 'flowSpecialListInfoThirteen',
        props: getProps,
        meta: {title: '第十三批特派员认证管理'}
      },
      {
        path: 'flowSpecialistEveryoneAuditList',
        component: _import('workflow/pages/flowSpecialistEveryAudit/flowSpecialistEveryoneAuditList'),
        name: 'flowSpecialistEveryoneAuditList',
        props: getProps,
        meta: {title: '人人都是科特派管理'}
      },
      {
        path: 'specialistCertificateList',
        component: _import('specialist/specialistCertificateList'),
        name: 'specialistCertificateList',
        props: getProps,
        meta: {title: '科特派证书列表'}
      },
      {
        path: 'dailyOnlineDurationList',
        component: _import('service/dailyOnlineDurationList'),
        name: 'dailyOnlineDurationList',
        props: getProps,
        meta: {title: '专家日常在线时长列表'}
      },
      {
        path: 'yearDurationStatistics',
        component: _import('service/yearDurationStatistics'),
        name: 'yearDurationStatistics',
        props: getProps,
        meta: {title: '全年时长统计表'}
      },
      {
        path: 'onlineOperationRecord',
        component: _import('service/onlineOperationRecord'),
        name: 'onlineOperationRecord',
        props: getProps,
        meta: {title: '在线操作记录'}
      },
      {
        path: 'workInformation',
        component: _import('service/workInformation'),
        name: 'workInformation',
        props: getProps,
        meta: {title: '工作日志'}
      },
      {
        path: 'workInformationForm',
        component: _import('service/workInformationForm'),
        name: 'workInformationForm',
        props: getProps,
        meta: {title: '工作日志表单'}
      },
      {
        path: 'integralRecord',
        component: _import('service/integralRecord'),
        name: 'integralRecord',
        props: getProps,
        meta: {title: '积分记录'}
      },
      {
        path: 'integralRecordStatistics',
        component: _import('service/integralRecordStatistics'),
        name: 'integralRecordStatistics',
        props: getProps,
        meta: {title: '积分统计'}
      }, // {
      //   path: 'technologyTrainList',
      //   component: _import('generated/technologyTrainList'),
      //   name: 'technologyTrainList',
      //   props: getProps,
      //   meta: {title: '科技培训'}
      // },

      {
        path: 'technologyTrainFlowList',
        component: _import('workflow/pages/technologyTrainFlow/technologyTrainFlowList'),
        name: 'technologyTrainFlowList',
        props: getProps,
        meta: {title: '科技培训列表'}
      },
      {
        path: 'activityList',
        component: _import('generated/activityList'),
        name: 'activityList',
        props: getProps,
        meta: {title: '辖区活动列表'}
      },
      {
        path: 'activityForm',
        component: _import('generated/activityForm'),
        name: 'activityForm',
        props: getProps,
        meta: {title: '辖区活动表单'}
      },
      {
        path: 'areaWorkList',
        component: _import('generated/areaWorkList'),
        name: 'areaWorkList',
        props: getProps,
        meta: {title: '辖区工作列表'}
      },
      {
        path: 'areaWorkForm',
        component: _import('generated/areaWorkForm'),
        name: 'areaWorkForm',
        props: getProps,
        meta: {title: '辖区工作表单'}
      },
      {
        path: 'flowWorkInformation',
        component: _import('workflow/pages/flowWorkInformation/flowWorkInformation'),
        name: 'flowWorkInformation',
        props: getProps,
        meta: {title: '工作日志列表'}
      },
      {
        path: 'flowServiceList',
        component: _import('workflow/pages/flowService/flowServiceList'),
        name: 'flowServiceList',
        props: getProps,
        meta: {title: '专家服务工单列表'}
      },
      {
        path: 'flowAreaWorkList',
        component: _import('workflow/pages/flowAreaWork/flowAreaWorkList'),
        name: 'flowAreaWorkList',
        props: getProps,
        meta: {title: '辖区工作列表'}
      },
      {
        path: 'flowActivityList',
        component: _import('workflow/pages/flowActivity/flowActivityList'),
        name: 'flowActivityList',
        props: getProps,
        meta: {title: '辖区活动列表'}
      },
      {
        path: 'flowConsultList',
        component: _import('workflow/pages/flowConsult/flowConsultList'),
        name: 'flowConsultList',
        props: getProps,
        meta: {title: '问答列表'}
      },
      {
        path: 'temporaryWorkList',
        component: _import('generated/temporaryWorkList'),
        name: 'temporaryWorkList',
        props: getProps,
        meta: {title: '临时工作'}
      },
      {
        path: 'temporaryWorkForm',
        component: _import('generated/temporaryWorkForm'),
        name: 'temporaryWorkForm',
        props: getProps,
        meta: {title: '临时性工作表单'}
      },
      {
        path: 'temporaryWorkFeedback',
        component: _import('generated/temporaryWorkFeedback'),
        name: 'temporaryWorkFeedback',
        props: getProps,
        meta: {title: '临时工作反馈情况'}
      },
      {
        path: 'temporaryWorkFeedbackForm',
        component: _import('generated/temporaryWorkFeedbackForm'),
        name: 'temporaryWorkFeedbackForm',
        props: getProps,
        meta: {title: '临时工作反馈表单'}
      },
      {
        path: 'enterpriseAdd',
        component: _import('enterprise/enterpriseAdd'),
        name: 'enterpriseAdd',
        props: getProps,
        meta: {title: '企业信息新增'}
      },
      {
        path: 'enterpriseForm',
        component: _import('enterprise/enterpriseForm'),
        name: 'enterpriseForm',
        props: getProps,
        meta: {title: '企业信息新增'}
      },
      {
        path: 'enterpriseList',
        component: _import('enterprise/enterpriseList'),
        name: 'enterpriseList',
        props: getProps,
        meta: {title: '企业信息新增'}
      }
    ]
  }
];

export default routers;
